import React from 'react';
import {connect} from 'react-redux';
import axios from 'axios';
import Account from './account';
import Agent from './agent';
import { useState, useEffect, useRef } from 'react';



//const BASE_DOMAIN = 'http://localhost:3000/api/v1/twilio/stats'
const BASE_DOMAIN = 'https://twilio.leadfusion.io'

export default function TaskStatsView(props) {


  const [email, setEmail]       = useState('');
  const [role, setRole]         = useState('agent');
  const [agents, setAgents]     = useState([]);
  const [accounts, setAccounts] = useState([]);

  const emailRef = useRef(email);
  const roleRef  = useRef(role);


  const getUrlParams = (key) => {
	  key = key.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
	  var regex = new RegExp('[\\?&]' + key + '=([^&#]*)');
	  var results = regex.exec(props.location.search);
	  return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }

  useEffect(() => {
    setEmail(getUrlParams('email'));
    setRole(getUrlParams('role'));
  }, []);


  useEffect(() => {
    if (email !== '' && role !== ''){
      emailRef.current = email;
      roleRef.current  = role;
      fetchData(email, role);
    }
  }, [email, role]);

 useEffect(() => {  
    const interval = setInterval(() => {
      fetchData(emailRef.current, roleRef.current)
    }, 60000);
    return () => clearInterval(interval);
  }, []);


  const fetchData = (email, role) => {
    let _this = this;
    axios.post(`${BASE_DOMAIN}/api/v1/twilio/stats`, {
        email: email,
        role: role
    })
    .then(items => {
      setAccounts(items.data.accounts);
      setAgents(items.data.agents)
    })
    .catch(error=> {
    })
}



	return (
    <div>
  	{/*this.state.role == 'supervisor' ? <Account rows={accounts}/> : ''*/ }
  	<Agent rows={agents}/>
  	</div>
    )

}



// WEBPACK FOOTER //
// ./src/components/TaskStatsView/index.js